import { useQuery } from "@tanstack/react-query";
import { listCustomerNotesAdmin, type ListCustomerNotesAdminParams } from "./customerNotesAdminApi";

export function useCustomerNotesAdmin(params: ListCustomerNotesAdminParams) {
  return useQuery({
    queryKey: ["admin", "customer-notes", params],
    queryFn: ({ signal }) => listCustomerNotesAdmin(params, signal),
  });
}
